export class HearingMethodType {
	public static Video = 'VID';
	public static Court = 'CRT';
	public static Phone = 'PHN';
}
